window.addEventListener('DOMContentLoaded', function () {
  const articleNavTabLists = document.querySelectorAll('.nav-tabs[role="tablist"]');
  if (!articleNavTabLists) return false;

  articleNavTabLists.forEach((list) => {
    if (list.offsetHeight > 300) {
      list.classList.add('big-size');
    }

    const listTabs = list.querySelectorAll('[role="presentation"]');
    listTabs.forEach((tab) => {
      tab.addEventListener('click', function (e) {
        const id = e.target.getAttribute('href');
        setTimeout( function () {
          document.querySelector(id).scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      })
    });
  });
});